import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTractorRevenueReport extends Layout {
    checkboxPageBreak: Checkbox;
    excludabletextboxDispatcher: ExcludableTextbox;
    excludabletextboxFleet: ExcludableTextbox;
    excludabletextboxSteamshipLine: ExcludableTextbox;
    excludabletextboxTractor: ExcludableTextbox;
    sourceTractorRevenue: DataSource;
    switchIncludeFuelSurchargeinRevenue: Switch;
    switchIncludeRemainingOtherChargesinRevenue: Switch;
    switchReportType: Switch;
    textboxDateRange: Textbox;
    textboxDateType: Textbox;
    textboxGroupBy: Textbox;
    textboxIncludeContainers: Textbox;
    textboxPayeeOption: Textbox;
}
